import { render, staticRenderFns } from "./AdsSection.vue?vue&type=template&id=16028646&"
import script from "./AdsSection.vue?vue&type=script&lang=js&"
export * from "./AdsSection.vue?vue&type=script&lang=js&"
import style0 from "./AdsSection.vue?vue&type=style&index=0&id=16028646&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports